import { Autocomplete } from "@mui/material";
import { Axios } from "api/axios";
import BootstrapTextField from "Common/BootstrapTextField";
import WarehouseAutocomplete from "Common/Components/InputComponent/WarehouseAutocomplete";
import CancelBackButton from "components/Buttons/CancelBackButton";
import SubmitButton from "components/Buttons/SubmitButton";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import LoadingSpinner from "components/LoaderErrorWrapper/LoadingSpinner";
import PageContainer from "components/PageContainer/PageContainer";
import { InwardType } from "Constants/inwardTypes";
import { autocompleteDropdownStyles } from "Constants/Style";
import { useAutoMinimizeSidebar } from "CustomHooks/useAutoMinimizeSidebar";
import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchLabourDropdownForForms } from "slices/Labour/thunk";
import { fetchWarehouseDropdown } from "slices/Master/Warehouse/thunk";
import { fetchSupplierBydropdown } from "slices/suppliers/thunk";
import { clearPendingLabourInwardDetails } from "slices/Warehouse/ItemInward2/PendingLabourInward/reducer";
import {
  createPendingLabourInward,
  fetchPendingLabourInwardById,
} from "slices/Warehouse/ItemInward2/PendingLabourInward/thunk";
import { showConfirm, showError, showValidationErrors } from "utils/swalHelper";
import * as Yup from "yup";
import ConfigureItems from "../ConfigureItemsTables/ConfigureItems";
import LabourReturnedItems from "../ConfigureItemsTables/LabourReturnedItems";

interface GRNFormValues {
  dispatch_id: string;
  dispatch_number: string;
  inward_date: string;
  labour_id: string;
  labour_name: string;
  upload_document: File | null;
  existing_document_file: string | null; // Store existing document URL for edit mode
  warehouse_id: string | null;
  warehouse_name: string | null;
  warehouse: string | null; // For WarehouseAutocomplete component
  remark: string;
  received_by: string;
  received_by_user_id: string;
}

const LabourInwardGNR: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const params = useParams<{ id?: string }>();
  const id = params.id;

  useEffect(() => {
    console.log("Dispatch id", id);
  }, [id]);

  // Redux state
  const { selectedInward: grnData, loading } = useSelector(
    (s: any) => s.PendingLabourInward
  );

  useEffect(() => {
    console.log("selected inward", grnData);
  }, [grnData]);

  // Auto-minimize sidebar on tablet screens
  useAutoMinimizeSidebar();

  // Check if we're in edit mode (ID in URL params)
  const inventoryId = params.id;
  const isEdit = Boolean(inventoryId);
  const [grnItems, setGrnItems] = useState<any[]>([]);
  const [labourOptions, setLabourOptions] = useState<any[]>([]);
  const [labourItems, setLabourItems] = useState<any[]>([]);
  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [supplierOptions, setSupplierOptions] = useState<any[]>([]);
  const [warehouseOptions, setWarehouseOptions] = useState<any[]>([]);
  const [isLoadingInitialData, setIsLoadingInitialData] = useState(false);
  const user = useSelector((state: any) => state.Login.user);

  useEffect(() => {
    console.log("Current logged In user", user);
  }, [user]);

  // Labour options
  useEffect(() => {
    const fetchLabourOptions = async () => {
      try {
        const response = await dispatch(fetchLabourDropdownForForms()).unwrap();
        setLabourOptions(response || []);
      } catch (error) {
        console.error("Error fetching supplier options:", error);
      }
    };
    fetchLabourOptions();
  }, [dispatch]);

  useEffect(() => {
    const fetchSupplierOptions = async () => {
      try {
        const response = await dispatch(fetchSupplierBydropdown()).unwrap();
        setSupplierOptions(response?.data || []);
      } catch (error) {
        console.error("Error fetching supplier options:", error);
      }
    };
    fetchSupplierOptions();
  }, [dispatch]);

  useEffect(() => {
    const fetchWarehouseOptions = async () => {
      try {
        const response = await dispatch(fetchWarehouseDropdown()).unwrap();
        setWarehouseOptions(response?.data || []);
      } catch (error) {
        console.error("Error fetching warehouse options:", error);
      }
    };
    fetchWarehouseOptions();
  }, [dispatch]);

  useEffect(() => {
    const fetchUserOptions = async () => {
      try {
        const response = await Axios.get("/users/dropdown/all");
        console.log("User Options:", response);
        setUserOptions(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching user options:", error);
        setUserOptions([]);
      }
    };

    fetchUserOptions();
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(fetchPendingLabourInwardById(id));
    }
    // else if(inventoryId) {
    //   dispatch(fetchGRNDetails(inventoryId));
    // }

    return () => {
      setLabourItems([]);
    };
  }, [id]);

  // Fetch GRN data
  useEffect(() => {
    if (!grnData || initialDataLoaded) return;

    formik.setFieldValue("dispatch_id", grnData.dispatch_id || "");
    formik.setFieldValue("dispatch_number", grnData.dispatch_number || "");
    // formik.setFieldValue(
    //   "inward_date",
    //   grnData.dispatch_date
    //     ? new Date(grnData.dispatch_date).toISOString().split("T")[0]
    //     : ""
    // );
    // formik.setFieldValue("remark", grnData.remark || "-");

    //  Labour details add here for edit
    const labourData = grnData.labour_details || grnData.labour;
    formik.setFieldValue("labour_id", labourData?.labour_id || "");
    formik.setFieldValue("labour_name", labourData?.labour_name || "");
    // formik.setFieldValue("existing_document_file", grnData.document || "-");

    const currentUser: any = userOptions.filter(
      (u) => user.user_id == u.user_id
    );
    const fullUserName = `${currentUser.first_name} ${currentUser.last_name}`;
    formik.setFieldValue("received_by", fullUserName || "");
    formik.setFieldValue("received_by_user_id", user.user_id || "-");
    formik.setFieldValue(
      "warehouse_id",
      grnData?.issued_from_warehouse?.warehouse_id || null
    );
    formik.setFieldValue(
      "warehouse_name",
      grnData?.issued_from_warehouse?.warehouse_name || null
    );
    formik.setFieldValue(
      "warehouse",
      grnData?.issued_from_warehouse?.warehouse_name || null
    );
    formik.setFieldValue("inward_type", "labour_inward");

    if (grnData.dispatch_items) {
      setLabourItems(grnData?.dispatch_items);
    }

    // Transform inventory_items to RowData format
    if (grnData.inventory_items && grnData.inventory_items.length > 0) {
      const transformedItems = grnData.inventory_items.map(
        (invItem: any, index: number) => {
          const quantity = invItem.quantity || 0;
          const rate = invItem.selling_price || 0;
          const amount = quantity * rate;

          return {
            id: `edit-${invItem.inventory_item_id || Date.now()}-${index}`,
            item_id: invItem.master_item?.item_id,
            itemName: invItem.master_item?.item_name,
            itemCode: invItem.master_item?.item_code,
            category: invItem.master_item?.category?.category_name,
            category_id: invItem.master_item?.category?.category_id,
            subCategory: invItem.master_item?.sub_category?.sub_category_name,
            sub_category_id: invItem.master_item?.sub_category?.sub_category_id,
            unit: invItem.master_item?.unit?.unit_name || "",
            quantity: quantity,
            rate: rate,
            amount: amount,
            remarks: invItem.remark || "",
          };
        }
      );

      setGrnItems(transformedItems);
    }
    setInitialDataLoaded(true);
  }, [grnData, dispatch]);
  // }, [isEdit, id, dispatch, navigate, initialDataLoaded, formik]);

  const validationSchema = Yup.object({
    // grn_no: Yup.string().required("Please enter GRN No."),
    dispatch_number: Yup.string().required("Please enter Dispatch number"),
    inward_date: Yup.string().required("Please select Inward Date"),
    labour_name: Yup.string().required("Please enter Labour name"),
    received_by: Yup.string().required("Please select Received By"),
    warehouse: Yup.string().required("Please select Warehouse"),
    remark: Yup.string(),
    upload_document: Yup.mixed()
      .nullable()
      .test("fileSize", "File size too large (max 2MB)", (file: any) => {
        if (!file) return true; // skip if empty
        return file.size <= 2 * 1024 * 1024;
      }),
  });

  // Get today's date in YYYY-MM-DD format for date input
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const formik = useFormik<GRNFormValues>({
    initialValues: {
      dispatch_id: "",
      dispatch_number: "",
      inward_date: getTodayDate(), // Auto-select today's date in add mode
      labour_name: "",
      labour_id: "",
      upload_document: null as File | null,
      existing_document_file: null as string | null,
      warehouse_id: "",
      warehouse_name: "",
      warehouse: "",
      remark: "",
      received_by: "",
      received_by_user_id: "",
    },

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Reset any previous errors
      // dispatch(resetGRNState());

      // ✅ Validate warehouse
      if (!values.warehouse_id || !values.warehouse) {
        formik.setFieldTouched("warehouse", true);
        showError("Please select a warehouse");
        return;
      }

      // ✅ Validate items
      if (grnItems.length === 0) {
        showError("Please add at least one item");
        return;
      }

      // ✅ Validate quantity for gnrdirect type
      // const invalidQuantity = grnItems.some((item, index) => {
      //   if (
      //     item.quantity === undefined ||
      //     item.quantity === null ||
      //     item.quantity <= 0
      //   ) {
      //     showError(`Quantity must be greater than 0 for row ${index + 1}`);
      //     return true;
      //   }
      //   return false;
      // });

      // if (invalidQuantity) return;

      // ✅ Validate rate for items that require rate (not LABOUR_INWARD)
      // const invalidRate = grnItems.some((item, index) => {
      //   if (item.rate === undefined || item.rate === null || item.rate <= 0) {
      //     showError(`Rate must be greater than 0 for row ${index + 1}`);
      //     return true;
      //   }
      //   return false;
      // });

      // if (invalidRate) return;

      // ✅ Build FormData
      const formData = buildFormData(values, grnItems, labourItems);

      console.log("------------------------------------------");
      formData.forEach((key, val) => {
        console.log(`${key} => ${val}`);
      });
      console.log("------------------------------------------");

      try {
        // if (isEdit && inventoryId) {
        //   // Update GRN
        //   await dispatch(
        //     updateGRN({ inventory_id: inventoryId, payload: formData })
        //   ).unwrap();
        //   toast.success("GRN updated successfully");
        // } else {
        // Create GRN
        await dispatch(createPendingLabourInward(formData)).unwrap();
        toast.success("GRN created successfully");
        // }
        navigate("/warehouse-item-inward");
      } catch (err: any) {
        handleSubmitError(err);
      }
    },
  });

  // Helper function to build FormData
  const buildFormData = useCallback(
    (values: GRNFormValues, items: any[], returnItems: any[]): FormData => {
      const formData = new FormData();
      formData.append("dispatch_id", values.dispatch_id);
      formData.append("dispatch_number", values.dispatch_number);
      formData.append("inward_date", values.inward_date);
      formData.append("labour_id", values.labour_id || "");
      formData.append("labour_name", values.labour_name || "");
      formData.append("remark", values.remark || "");
      formData.append("warehouse_id", values.warehouse_id || "");
      formData.append("warehouse_name", values.warehouse_name || "");
      formData.append("received_by", values.received_by_user_id || "");
      // formData.append("received_by_user_id", values.received_by_user_id || "");
      formData.append("inward_type", InwardType.LABOUR_INWARD);

      // Append file if it exists (must be File object, not string)
      if (values.upload_document && values.upload_document instanceof File) {
        formData.append("document_file", values.upload_document);
      }

      // Transform RowData to GRNItem format
      const transformedItems = items.map((row: any) => {
        const grnItem: any = {
          item_type: "new",
          item_id: row.item_id,
          item_name: row.itemName,
          item_code: row.itemCode,
          category_id: row.category_id,
          category_name: row.category,
          sub_category_id: row.sub_category_id,
          sub_category_name: row.subCategory,
          remark: row.remark || null,
          quantity: row.received_quantity,
        };

        const quantity = Number(row.received_quantity) || 0;
        grnItem.grn_items_details = [
          {
            quantity: quantity,
            selling_price: row.rate ? Number(row.rate) : null,
            remark: row.remarks || null,
          },
        ];

        return grnItem;
      });

      const transformedReturnItems = returnItems
        .filter((row: any) => {
          // Filter out returned items with zero or negative quantity
          const returnQty = Number(row.return_quantity) || 0;
          return returnQty > 0;
        })
        .map((row: any) => {
          return {
            item_type: "returned",

            dispatch_item_id: row.dispatch_item_id,
            item_id: row.master_item?.item_id,
            item_name: row.master_item?.item_name,
            item_code: row.master_item?.item_code,

            category_id: row.category?.category_id,
            category_name: row.category?.category_name,

            sub_category_id: row.sub_category?.sub_category_id,
            sub_category_name: row.sub_category?.sub_category_name,

            unit_id: row.unit?.unit_id,
            unit_name: row.unit?.unit_name,

            remark: row.remark || null,
            issued_quantity: Number(row.dispatch_quantity) || 0,

            // Quantity fields
            // dispatch_quantity: Number(row.dispatch_quantity) || 0,
            // total_quantity: Number(row.dispatch_quantity) || 0,
            // quantity: Number(row.dispatch_quantity) || 0,
            quantity: Number(row.return_quantity) || 0,

            // bags array (copy as-is)
            bags: row.item_details?.bags || [],

            // Return items detail (if required)
            grn_items_details: [
              {
                quantity: Number(row.return_quantity) || 0,
                remark: row.remark || null,
              },
            ],
          };
        });

      // Combine both arrays
      const finalItems = [...transformedItems, ...transformedReturnItems];

      // console.log("--------------------------------------------------");
      // finalItems.forEach((item, key) => {
      //   console.log(`${key} => ${key}`);
      // });
      // console.log("--------------------------------------------------");

      formData.append("grn_items", JSON.stringify(finalItems));
      return formData;
    },
    []
  );

  // Helper function to handle submit errors
  const handleSubmitError = useCallback((err: any) => {
    const responseData = err?.response?.data || err;
    const validationErrors = responseData?.data?.errors || responseData?.errors;

    if (Array.isArray(validationErrors) && validationErrors.length > 0) {
      try {
        showValidationErrors(validationErrors);
      } catch (swalError) {
        toast.error(validationErrors.join("; "));
      }
    } else {
      const errorMessage =
        responseData?.error ||
        responseData?.message ||
        "Failed to process GRN. Please try again.";
      console.log("Error message:", errorMessage);
      toast.error(errorMessage);
    }
  }, []);

  const handleItemsUpdated = (items: any[]) => {
    setGrnItems(items);
  };

  const handleLabourItemsUpdated = (items: any[]) => {
    setLabourItems(items);
  };

  useEffect(() => {
    console.log("Updated GRN Items: ", grnItems);
  }, [grnItems]);

  useEffect(() => {
    console.log("Updated Labour Items: ", labourItems);
  }, [labourItems]);

  useEffect(() => {
    return () => {
      setLabourItems([]);
      dispatch(clearPendingLabourInwardDetails()); // Reset on unmount
    };
  }, []);

  return (
    <PageContainer>
      <FormHeader
        title="Create GRN (Labour)"
        firstLabel="Labour"
        secondLabel="Create GRN"
        handleArrowClick={() => navigate("/warehouse-item-inward")}
      />

      {loading || !initialDataLoaded ? (
        <LoadingSpinner />
      ) : (
        <Form autoComplete="off" onSubmit={formik.handleSubmit}>
          <Row>
            {/* Inward Date */}
            <Col lg={3} md={4}>
              <div className="mb-3">
                <Form.Label>
                  Inward Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="inward_date"
                  value={formik.values.inward_date}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    !!formik.errors.inward_date && formik.touched.inward_date
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.inward_date}
                </Form.Control.Feedback>
              </div>
            </Col>

            {/* Dispatch No. */}
            <Col lg={3} md={4}>
              <div className="mb-3">
                <Form.Label>
                  Dispatch No. <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  name="dispatch_number"
                  // placeholder="Enter Dispatch Number"
                  value={formik.values.dispatch_number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    !!formik.errors.dispatch_number &&
                    formik.touched.dispatch_number
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.dispatch_id}
                </Form.Control.Feedback>
              </div>
            </Col>

            {/* Labour */}
            <Col lg={3} md={4}>
              <div className="mb-3">
                <Form.Label>
                  Labour Name <span className="text-danger">*</span>
                </Form.Label>

                <Autocomplete
                  disabled
                  options={labourOptions}
                  getOptionLabel={(option: any) => option?.labour_name || ""}
                  // ✅ Match by ID, not name
                  value={
                    labourOptions.find(
                      (opt: any) => opt.labour_id === formik.values.labour_id
                    ) || null
                  }
                  onChange={(event, selectedOption: any) => {
                    formik.setFieldValue(
                      "labour_id",
                      selectedOption?.labour_id || ""
                    );
                    formik.setFieldValue(
                      "labour_name",
                      selectedOption?.labour_name || ""
                    );
                    formik.setFieldTouched("labour_name", true);
                  }}
                  onBlur={() => formik.setFieldTouched("labour_name", true)}
                  renderInput={(params) => (
                    <BootstrapTextField
                      {...params}
                      placeholder="Select Labour"
                      name="labour_name"
                      error={
                        formik.touched.labour_name &&
                        Boolean(formik.errors.labour_name)
                      }
                      helperText={
                        formik.touched.labour_name && formik.errors.labour_name
                      }
                      fullWidth
                      size="small"
                      sx={{
                        background: "#FFF",
                        ...autocompleteDropdownStyles.inputSx,
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#ced4da",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ced4da",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ced4da",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) =>
                    autocompleteDropdownStyles.renderOption(
                      props,
                      option,
                      (opt: any) => opt?.labour_name || ""
                    )
                  }
                  ListboxProps={autocompleteDropdownStyles.ListboxProps}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&:hover fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#ced4da",
                      },
                    },
                  }}
                />
              </div>
            </Col>

            {/* Received By */}
            <Col lg={3} md={4}>
              <div className="mb-3">
                <Form.Label>
                  Received By <span className="text-danger">*</span>
                </Form.Label>
                <Autocomplete
                  options={userOptions}
                  getOptionLabel={(option: any) =>
                    option?.first_name && option?.last_name
                      ? `${option.first_name} ${option.last_name}`
                      : option?.username || option?.email || ""
                  }
                  value={
                    userOptions.find(
                      (opt: any) =>
                        opt.user_id === formik.values.received_by_user_id
                    ) || null
                  }
                  onChange={(event, selectedOption: any) => {
                    formik.setFieldValue(
                      "received_by_user_id",
                      selectedOption?.user_id || ""
                    );
                    formik.setFieldValue(
                      "received_by",
                      selectedOption?.first_name && selectedOption?.last_name
                        ? `${selectedOption.first_name} ${selectedOption.last_name}`
                        : selectedOption?.username || ""
                    );
                  }}
                  renderInput={(params) => (
                    <BootstrapTextField
                      {...params}
                      placeholder="Select User"
                      name="received_by"
                      error={
                        formik.touched.received_by &&
                        Boolean(formik.errors.received_by)
                      }
                      helperText={
                        formik.touched.received_by && formik.errors.received_by
                      }
                      fullWidth
                      size="small"
                      sx={{
                        background: "#FFF",
                        ...autocompleteDropdownStyles.inputSx,
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#ced4da",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ced4da",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ced4da",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) =>
                    autocompleteDropdownStyles.renderOption(
                      props,
                      option,
                      (opt: any) =>
                        opt?.first_name && opt?.last_name
                          ? `${opt.first_name} ${opt.last_name}`
                          : opt?.username || opt?.email || ""
                    )
                  }
                  ListboxProps={autocompleteDropdownStyles.ListboxProps}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&:hover fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#ced4da",
                      },
                    },
                  }}
                />
              </div>
            </Col>

            {/* Warehouse */}
            <Col lg={3} md={4}>
              <div className="mb-3">
                <Form.Label>
                  Warehouse <span className="text-danger">*</span>
                </Form.Label>
                <WarehouseAutocomplete
                  options={warehouseOptions}
                  value={formik.values.warehouse}
                  valueType="warehouse_name"
                  showWarehouseType={true}
                  formik={formik}
                  formikFieldId="warehouse_id"
                  formikFieldName="warehouse"
                  name="warehouse"
                  inputSx={{
                    background: "#FFF",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&:hover fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#ced4da",
                      },
                    },
                  }}
                  customSx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&:hover fieldset": {
                        borderColor: "#ced4da",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#ced4da",
                      },
                    },
                  }}
                  onChange={(warehouseId, warehouseName) => {
                    formik.setFieldValue("warehouse_id", warehouseId);
                    formik.setFieldValue("warehouse_name", warehouseName);
                    formik.setFieldValue("warehouse", warehouseName);
                    // Clear error if a valid warehouse is selected
                    if (warehouseName) {
                      formik.setFieldError("warehouse", undefined);
                    }
                  }}
                  onBlur={() => formik.setFieldTouched("warehouse", true)}
                />
              </div>
            </Col>

            {/* Remark */}
            <Col lg={3} md={4}>
              <div className="mb-3">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  type="text"
                  name="remark"
                  placeholder="Enter Remark"
                  value={formik.values.remark}
                  onChange={formik.handleChange}
                />
              </div>
            </Col>

            {/* Upload document */}
            {/* Document */}
            <Col lg={3}>
              <div className="mb-3">
                <Form.Label>
                  Upload document
                  {/* <span className="text-danger">*</span> */}
                </Form.Label>

                {/* Custom styled box */}
                <div
                  className={`d-flex align-items-center justify-content-between p-2 border rounded ${
                    formik.errors.upload_document &&
                    formik.touched.upload_document
                      ? "border-danger"
                      : ""
                  }`}
                  style={{
                    height: "40px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    backgroundColor: "#fff",
                    borderColor:
                      formik.errors.upload_document &&
                      formik.touched.upload_document
                        ? "#dc3545"
                        : "#ced4da",
                  }}
                  onMouseEnter={(e) => {
                    if (
                      !formik.errors.upload_document ||
                      !formik.touched.upload_document
                    ) {
                      e.currentTarget.style.borderColor = "#80bdff";
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (
                      !formik.errors.upload_document ||
                      !formik.touched.upload_document
                    ) {
                      e.currentTarget.style.borderColor = "#ced4da";
                      e.currentTarget.style.backgroundColor = "#fff";
                    }
                  }}
                  onClick={() => {
                    document.getElementById("uploadDocInput")?.click();
                  }}
                >
                  <span
                    className="text-muted"
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      marginRight: "8px",
                      minWidth: 0,
                    }}
                    title={
                      formik.values.upload_document instanceof File
                        ? formik.values.upload_document.name
                        : formik.values.existing_document_file
                        ? formik.values.existing_document_file
                            .split("/")
                            .pop() || "Existing Document"
                        : "Click to upload document"
                    }
                  >
                    {formik.values.upload_document instanceof File ? (
                      formik.values.upload_document.name
                    ) : formik.values.existing_document_file ? (
                      <a
                        href={formik.values.existing_document_file}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="text-decoration-none text-primary"
                        style={{
                          cursor: "pointer",
                          display: "inline-block",
                          maxWidth: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={
                          formik.values.existing_document_file
                            .split("/")
                            .pop() || "Existing Document"
                        }
                      >
                        {formik.values.existing_document_file
                          .split("/")
                          .pop() || "Existing Document"}
                      </a>
                    ) : (
                      "Click to upload document"
                    )}
                  </span>

                  {/* Action buttons */}
                  <div
                    className="d-flex align-items-center gap-2"
                    onClick={(e) => e.stopPropagation()}
                    style={{ flexShrink: 0 }}
                  >
                    {formik.values.upload_document instanceof File ? (
                      <>
                        <i
                          className="bi bi-upload text-primary"
                          style={{
                            cursor: "pointer",
                            fontSize: "1rem",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            document.getElementById("uploadDocInput")?.click();
                          }}
                          title="Change document"
                        ></i>
                        <i
                          className="bi bi-x-circle text-danger"
                          style={{
                            cursor: "pointer",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            formik.setFieldValue("upload_document", null);
                            formik.setFieldValue(
                              "existing_document_file",
                              null
                            );
                            // Reset file input
                            const fileInput = document.getElementById(
                              "uploadDocInput"
                            ) as HTMLInputElement;
                            if (fileInput) {
                              fileInput.value = "";
                            }
                          }}
                          title="Remove document"
                        ></i>
                      </>
                    ) : formik.values.existing_document_file ? (
                      <>
                        <a
                          href={formik.values.existing_document_file}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          title="View document"
                        >
                          <i
                            className="bi bi-eye text-primary"
                            style={{
                              cursor: "pointer",
                              fontSize: "1rem",
                              transition: "transform 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.1)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          ></i>
                        </a>
                        <i
                          className="bi bi-upload text-primary"
                          style={{
                            cursor: "pointer",
                            fontSize: "1rem",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            document.getElementById("uploadDocInput")?.click();
                          }}
                          title="Change document"
                        ></i>
                        <i
                          className="bi bi-x-circle text-danger"
                          style={{
                            cursor: "pointer",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            formik.setFieldValue("upload_document", null);
                            formik.setFieldValue(
                              "existing_document_file",
                              null
                            );
                            // Reset file input
                            const fileInput = document.getElementById(
                              "uploadDocInput"
                            ) as HTMLInputElement;
                            if (fileInput) {
                              fileInput.value = "";
                            }
                          }}
                          title="Remove document"
                        ></i>
                      </>
                    ) : (
                      <i
                        className="bi bi-upload"
                        style={{
                          cursor: "pointer",
                          fontSize: "1rem",
                          color: "#6c757d",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = "#007bff";
                          e.currentTarget.style.transform = "scale(1.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = "#6c757d";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      ></i>
                    )}
                  </div>
                </div>

                {/* Hidden real file input */}
                <Form.Control
                  id="uploadDocInput"
                  type="file"
                  name="upload_document"
                  style={{ display: "none" }}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const file = event.currentTarget.files?.[0] || null;
                    formik.setFieldValue("upload_document", file);
                    // Clear existing_document_file when a new file is uploaded
                    if (file) {
                      formik.setFieldValue("existing_document_file", null);
                    }
                    formik.setFieldTouched("upload_document", true);
                  }}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    !!formik.errors.upload_document &&
                    formik.touched.upload_document
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {formik.errors.upload_document}
                </Form.Control.Feedback>
              </div>
            </Col>
          </Row>

          <hr />

          <ConfigureItems
            inwardType={InwardType.LABOUR_INWARD}
            onItemsUpdated={handleItemsUpdated}
            initialItems={loading ? grnItems : undefined}
          />

          <LabourReturnedItems
            onItemsUpdated={handleLabourItemsUpdated}
            initialItems={labourItems}
          />

          <div className="d-flex justify-content-center gap-3 py-3">
            <CancelBackButton
              label="Cancel"
              onClick={() => {
                showConfirm(
                  "Any unsaved changes will be lost.",
                  "Are you sure?",
                  "Yes",
                  "No"
                ).then((result) => {
                  if (result.isConfirmed) {
                    dispatch(clearPendingLabourInwardDetails());
                    navigate("/warehouse-item-inward");
                  }
                });
              }}
            />

            <SubmitButton
              isSubmitting={formik.isSubmitting}
              labels={{
                create: "Create GRN",
                submitting: "Creating GRN",
              }}
            />
          </div>
        </Form>
      )}
    </PageContainer>
  );
};

export default LabourInwardGNR;
